"use strict";

var _regeneratorRuntime = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LinkedListItem_1 = require("./LinkedListItem");
/**
 * Implements a linked list structure
 * @typeparam T Type of values within this LinkedList
 */


var LinkedList = /*#__PURE__*/function () {
  /**
   * @param values Values to be added upfront into list
   */
  function LinkedList(values) {
    var _this = this;

    _classCallCheck(this, LinkedList);

    /**
     * Current length of this LinkedList.
     * Note that this does not work anymore if you for some reason add your own LinkedListItems to LinkedList by hand
     */
    this.length = 0;
    /**
     * Given to own LinkedListItem's for following jobs regarding an unlink:
     * - If item is first item, set the next item as first item
     * - If item is last item, set the previous item as last item
     * - Decrease length
     * @param item Item that has been unlinked
     */

    this.unlinkCleanup = function (item) {
      if (_this.first === item) {
        _this.first = _this.first.behind;
      }

      if (_this.last === item) {
        _this.last = _this.last.before;
      }

      _this.length--;
    };

    if (values) {
      if (values instanceof LinkedList) {
        values = values.values();
      }

      var _iterator = _createForOfIteratorHelper(values),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          this.push(value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  /**
   * As Array#every() given callback is called for every element until one call returns falsy or all elements had been processed
   * @returns `false` if there was a falsy response from the callback, `true` if all elements have been processed "falselesly"
   * @see Array#every
   */


  _createClass(LinkedList, [{
    key: "every",
    value: function every(callback, thisArg) {
      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      var _iterator2 = _createForOfIteratorHelper(this.keys()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;

          if (!callback(item.value, item, this)) {
            return false;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return true;
    }
    /**
     * Filters values into a new LinkedList
     * @param callback decides wether given element should be part of new LinkedList
     * @see Array#filter
     */

  }, {
    key: "filter",
    value: function filter(callback, thisArg) {
      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      var newList = new LinkedList();

      var _iterator3 = _createForOfIteratorHelper(this),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              item = _step3$value[0],
              value = _step3$value[1];

          if (callback(value, item, this)) {
            newList.push(value);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return newList;
    }
    /**
     * Returns value for which given callback returns truthy
     * @param callback runs for every value in LinkedList. If it returns truthy, current value is returned.
     * @see Array#find
     */

  }, {
    key: "find",
    value: function find(callback, thisArg) {
      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      var _iterator4 = _createForOfIteratorHelper(this),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              item = _step4$value[0],
              value = _step4$value[1];

          if (callback(value, item, this)) {
            return value;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
    /**
     * Returns the LinkedListItem for which given callback returns truthy
     * @param callback runs for every LinkedListItem in LinkedList. If it returns truthy, current LinkedListItem is returned.
     * @see Array#findIndex
     */

  }, {
    key: "findItem",
    value: function findItem(callback, thisArg) {
      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      var _iterator5 = _createForOfIteratorHelper(this),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              item = _step5$value[0],
              value = _step5$value[1];

          if (callback(value, item, this)) {
            return item;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    /**
     * Iterates this LinkedList's items and values
     * @param callback Gets every value in LinkedList once with corresponding LinkedListItem and LinkedList
     * @param thisArg If given, callback will be bound here
     * @see Array#forEach
     */

  }, {
    key: "forEach",
    value: function forEach(callback, thisArg) {
      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      var _iterator6 = _createForOfIteratorHelper(this),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              item = _step6$value[0],
              value = _step6$value[1];

          callback(value, item, this);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    /**
     * Checks if value can be found within LinkedList, starting from fromIndex, if given.
     * @param value value to be found in this
     * @param fromIndex Starting index. Supports negative values for which `this.size - 1 + fromIndex` will be used as starting point.
     * @returns true if value could be found in LinkedList (respecting fromIndex), false otherwhise
     * @see Array#includes
     */

  }, {
    key: "includes",
    value: function includes(value) {
      var fromIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var current = this.getItemByIndex(fromIndex);

      while (current) {
        if (current.value === value) {
          return true;
        }

        current = current.behind;
      }

      return false;
    }
    /**
     * Searches forward for given value and returns the first corresponding LinkedListItem found
     * @param searchedValue Value to be found
     * @param fromIndex Index to start from
     * @see Array#indexOf
     */

  }, {
    key: "itemOf",
    value: function itemOf(searchedValue) {
      var fromIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var current = this.getItemByIndex(fromIndex);

      while (current) {
        if (current.value === searchedValue) {
          return current;
        }

        current = current.behind;
      }

      return;
    }
    /**
     * Searches backwards for given value and returns the first corresponding LinkedListItem found
     * @param searchedValue Value to be found
     * @param fromIndex Index to start from
     * @see Array#indexOf
     */

  }, {
    key: "lastItemOf",
    value: function lastItemOf(searchedValue) {
      var fromIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var current = this.getItemByIndex(fromIndex);

      while (current) {
        if (current.value === searchedValue) {
          return current;
        }

        current = current.before;
      }

      return;
    }
    /**
     * Creates a new LinkedList with each of its itesm representing the output of the callback with each item in current LinkedList.
     * @param callback Gets value, LinkedListeItem and LinkedList. The response will be used as value in the new LinkedList
     * @param thisArg If given, callback is bound to thisArg
     * @see Array#map
     */

  }, {
    key: "map",
    value: function map(callback, thisArg) {
      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      var newList = new LinkedList();

      var _iterator7 = _createForOfIteratorHelper(this),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _step7$value = _slicedToArray(_step7.value, 2),
              item = _step7$value[0],
              value = _step7$value[1];

          newList.push(callback(value, item, this));
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return newList;
    }
  }, {
    key: "reduce",
    value: function reduce(callback, initialValue) {
      var current = this.first;

      if (!current) {
        if (!initialValue) {
          throw new TypeError("Empty accumulator on empty LinkedList is not allowed.");
        }

        return initialValue;
      }

      if (initialValue === undefined) {
        initialValue = current.value;

        if (!current.behind) {
          return initialValue;
        }

        current = current.behind;
      } else {
        initialValue = initialValue;
      }

      do {
        initialValue = callback(initialValue, current.value, current, this);
        current = current.behind;
      } while (current);

      return initialValue;
    }
  }, {
    key: "reduceRight",
    value: function reduceRight(callback, initialValue) {
      var current = this.last;

      if (!current) {
        if (!initialValue) {
          throw new TypeError("Empty accumulator on empty LinkedList is not allowed.");
        }

        return initialValue;
      } // let accumulator: V | T;


      if (initialValue === undefined) {
        initialValue = current.value;

        if (!current.before) {
          return initialValue;
        }

        current = current.before;
      } else {
        initialValue = initialValue;
      }

      do {
        initialValue = callback(initialValue, current.value, current, this);
        current = current.before;
      } while (current);

      return initialValue;
    }
    /**
     * Runs callback for every entry and returns true immediately if call of callback returns truthy.
     * @param callback called for every element. If response is truthy, iteration
     * @param thisArg If set, callback is bound to this
     * @returns `true` once a callback call returns truthy, `false` if none returned truthy.
     */

  }, {
    key: "some",
    value: function some(callback, thisArg) {
      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      var _iterator8 = _createForOfIteratorHelper(this),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _step8$value = _slicedToArray(_step8.value, 2),
              item = _step8$value[0],
              value = _step8$value[1];

          if (callback(value, item, this)) {
            return true;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return false;
    }
    /**
     * Joins values within this by given separator. Uses Array#join directly.
     * @param separator separator to be used
     * @see Array#join
     */

  }, {
    key: "join",
    value: function join(separator) {
      return _toConsumableArray(this.values()).join(separator);
    }
    /**
     * Concats given values and returns a new LinkedList with all given values.
     * If LinkedList's are given, they will be spread.
     * @param others Other values or lists to be concat'ed together
     * @see Array#concat
     */

  }, {
    key: "concat",
    value: function concat() {
      var newList = new LinkedList(this);

      for (var _len = arguments.length, others = new Array(_len), _key = 0; _key < _len; _key++) {
        others[_key] = arguments[_key];
      }

      for (var _i = 0, _others = others; _i < _others.length; _i++) {
        var other = _others[_i];

        if (other instanceof LinkedList) {
          newList.push.apply(newList, _toConsumableArray(other.values()));
        } else {
          newList.push(other);
        }
      }

      return newList;
    }
    /**
     * Removes the last LinkedListItem and returns its inner value
     */

  }, {
    key: "pop",
    value: function pop() {
      if (!this.last) {
        return;
      }

      var item = this.last;
      item.unlink();
      return item.value;
    }
    /**
     * Adds given values on the end of this LinkedList
     * @param values Values to be added
     */

  }, {
    key: "push",
    value: function push() {
      for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        values[_key2] = arguments[_key2];
      }

      for (var _i2 = 0, _values = values; _i2 < _values.length; _i2++) {
        var value = _values[_i2];
        var item = new LinkedListItem_1.LinkedListItem(value, this.unlinkCleanup);

        if (!this.first || !this.last) {
          this.first = this.last = item;
        } else {
          this.last.insertBehind(item);
          this.last = item;
        }

        this.length++;
      }
    }
    /**
     * Adds given values to the beginning of this LinkedList
     * @param values Values to be added
     */

  }, {
    key: "unshift",
    value: function unshift() {
      for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        values[_key3] = arguments[_key3];
      }

      for (var _i3 = 0, _values2 = values; _i3 < _values2.length; _i3++) {
        var value = _values2[_i3];
        var item = new LinkedListItem_1.LinkedListItem(value, this.unlinkCleanup);

        if (!this.last || !this.first) {
          this.first = this.last = item;
        } else {
          item.insertBehind(this.first);
          this.first = item;
        }

        this.length++;
      }
    }
    /**
     * Removes first occurrence of value found.
     * @param value value to remove from LinkedList
     */

  }, {
    key: "remove",
    value: function remove(value) {
      var _iterator9 = _createForOfIteratorHelper(this.keys()),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var item = _step9.value;

          if (item.value === value) {
            item.unlink();
            return true;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return false;
    }
    /**
     * Removes every occurrance of value within this.
     * @param value value to remove from LinkedList
     */

  }, {
    key: "removeAllOccurrences",
    value: function removeAllOccurrences(value) {
      var foundSomethingToDelete = false;

      var _iterator10 = _createForOfIteratorHelper(this.keys()),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var item = _step10.value;

          if (item.value === value) {
            item.unlink();
            foundSomethingToDelete = true;
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      return foundSomethingToDelete;
    }
    /**
     * Returns and removes first element from LinkedList
     */

  }, {
    key: "shift",
    value: function shift() {
      if (!this.first) {
        return;
      }

      var item = this.first;
      item.unlink();
      return item.value;
    }
    /**
     * Returns LinkedListItem and value for every entry of this LinkedList
     */

  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var current;
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              current = this.first;

              if (current) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return [current, current.value];

            case 5:
              current = current.behind;

            case 6:
              if (current) {
                _context.next = 3;
                break;
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
    /**
     * Returns LinkedListItem and value for every entry of this LinkedList
     * @see LinkedList#Symbol.iterator
     */

  }, {
    key: "entries",
    value: function entries() {
      return this[Symbol.iterator]();
    }
    /**
     * Iterates the LinkedListItem's of this LinkedList
     */

  }, {
    key: "keys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
      var current;
      return _regeneratorRuntime.wrap(function keys$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              current = this.first;

              if (current) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _context2.next = 5;
              return current;

            case 5:
              current = current.behind;

            case 6:
              if (current) {
                _context2.next = 3;
                break;
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, keys, this);
    })
    /**
     * Returns a value for every entry of this LinkedList
     */

  }, {
    key: "values",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function values() {
      var current;
      return _regeneratorRuntime.wrap(function values$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              current = this.first;

              if (current) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              _context3.next = 5;
              return current.value;

            case 5:
              current = current.behind;

            case 6:
              if (current) {
                _context3.next = 3;
                break;
              }

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, values, this);
    })
    /**
     * Returns the item by given index.
     * Supports negative values and will return the item at `LinkedList.size - 1 + index` in that case.
     * @param index Index of item to get from list
     */

  }, {
    key: "getItemByIndex",
    value: function getItemByIndex(index) {
      if (index === undefined) {
        throw new Error("index must be a number!");
      }

      if (!this.first) {
        return;
      }

      var current;

      if (index > 0) {
        current = this.first;

        while (current && index--) {
          current = current.behind;
        }
      } else if (index < 0) {
        current = this.last;

        while (current && ++index) {
          current = current.before;
        }
      } else {
        return this.first;
      }

      return current;
    }
  }]);

  return LinkedList;
}();

exports.LinkedList = LinkedList;